import React, { useCallback, useMemo, useState } from "react";
import styles from "./index.module.less";
import { FocusSDK, isFocusEnv } from "@/utils";
import { convertEmployeeToString } from "@/utils/chat/message";
import ChatState from "@/types/chat/State";
import { connect } from "dva";
import { throttle } from "lodash";
import { Popover } from "antd";
import { getShareHintMessageBody } from "@/components/chat/utils/commonMessageModal";
import { getAIChatWinSessionId } from "@/utils/chat/session";
import ChatContext from "@/components/chat/context";
import { TYPE_KEY_SHARE_GREET_MULTI } from "@/contant/chat";

function BtnAiChat(props: any) {
  const { lastMessage } = React.useContext(ChatContext);
  const { className, currentEmployee, llmSetting } = props;
  console.log(`tj:>>>BtnAiChat>>>>handleLaunch>>>>`, llmSetting);
  const handleLaunch = async () => {
    if (isFocusEnv()) {
      const sid = await getAIChatWinSessionId();
      FocusSDK.launchAIChatSession(
        `aiRobot:dd.notice:focus.bot:${convertEmployeeToString(currentEmployee)}:chat`,
        () => {},
        true
      );
      // 欢迎语
      console.log(`tj:>>>handleLaunch>>>>`, llmSetting);
      const msg = await getShareHintMessageBody(currentEmployee, llmSetting);
      msg.sessionId = sid;
      FocusSDK.sendMainMessage("aichat.chatEvent", { sessionId: sid, data: msg });
    }
  };

  const contentPop = useMemo(() => {
    return (
      <div className={styles["pop-wrap"]}>
        <div className={styles["right"]}>
          <div className={styles["title"]}>智能助理</div>
          <div className={styles["text"]}>
            我是您的智能办公助手，很高兴为您提供服务。快来跟我交流吧！
          </div>
        </div>
      </div>
    );
  }, []);
  return (
    <Popover content={contentPop} trigger="hover" overlayClassName={`${styles["pop-content"]}`}>
      <div
        className={`${className} ${styles["ai-btn-wrap"]} `}
        onClick={throttle(handleLaunch, 3 * 1000)}
        clstag="pageclick|keycount|Xtbg_Frame_SmartAssistant"
      >
        <span className={styles["icon"]} />
      </div>
    </Popover>
  );
}

function mapStateToProps({ chat }: any) {
  const { currentEmployee, llmSetting } = chat as ChatState;
  return {
    currentEmployee,
    llmSetting
  };
}
function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(BtnAiChat);
